<div class="nopage-container">
  <div class="w-full mt-10 flex justify-center items-center">
    <p class="text-[1.4em]">{{ "nopage.error_message" | transloco }}</p>
  </div>
  <div class="w-full mt-10 flex justify-center items-center">
    <p-button
      label="{{ 'nopage.buttons.goHome' | transloco }}"
      [link]="true"
      (click)="goHome()"
    ></p-button>
  </div>
</div>
